import axios from 'axios';

async function EnviarSMSValidacion(dni: string, ape_y_nom: string, email: string, celular: string) {
    
    const url = "https://endpoints.mapsys.com.ar/validar/enviar_sms_validacion"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "dni": dni,
            "apeynom": ape_y_nom,
            "email": email,
            "celular": celular
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

export default EnviarSMSValidacion;